import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authenticationAPI = createApi({
  reducerPath: "authenticationAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_DEV_BASE_URL,
  }),
  endpoints: (builder) => ({
    getOTP: builder.mutation({
      query: (payload) => ({
        url: "auth/send-otp",
        method: "POST",
        body: payload,
      }),
    }),
    verifyOTP: builder.mutation({
      query: (payload) => ({
        url: "user/login",
        method: "POST",
        body: payload,
      }),
    }),
    verifyAuctionCode: builder.query({
      query: (code) => `tournament/verify-code/${code}`,
    }),
    register: builder.mutation({
      query: (payload) => ({
        url: "user/register",
        method: "POST",
        body: payload,
      }),
    }),
    uploadProfilePic: builder.mutation({
      query: (payload) => ({
        headers: {
          "Content-Type": "multipart/form-data",
        },
        url: "/user/uploadProfilePic",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetOTPMutation,
  useVerifyOTPMutation,
  useVerifyAuctionCodeQuery,
  useLazyVerifyAuctionCodeQuery,
  useRegisterMutation,
  useUploadProfilePicMutation,
} = authenticationAPI;
